/**
 * A number box with its unit inside the right edge — cb-04's 30px recipe
 * inputs (`0.2 h`), cb-19's 36px How much fields and 34px tier cells, and
 * cb-22's 46px phone fields (a tier card's Up to and Per).
 *
 * One component for the four sizes, because they are one control drawn at
 * four densities: the unit is part of the value, so it lives inside the
 * border and the focus ring belongs to the whole box.
 */
import { cn } from '../../lib/cn.js'

export function UnitInput({
  value, onChange, unit, label, size = 'field', width, dim, readOnly, placeholder, align = 'left', prefix,
}: {
  value: string
  onChange?: (value: string) => void
  unit?: string
  label: string
  /** `small` 30 (a recipe row), `row` 34 (a tier), `field` 36 (How much), `phone` 46 (cb-22 · 4). */
  size?: 'small' | 'row' | 'field' | 'phone'
  width?: number
  /** A rate of 0 is drawn faint — that is what *once* looks like (§6.3). */
  dim?: boolean
  readOnly?: boolean
  placeholder?: string
  align?: 'left' | 'right'
  /** A money cell's `$`, inside the left edge (cb-19 · Quoted / crew h). */
  prefix?: string
}) {
  return (
    <label
      style={width ? { width } : undefined}
      className={cn('flex shrink-0 items-center gap-1 rounded-control border border-line px-[9px]',
        'focus-within:border-accent-line focus-within:ring-2 focus-within:ring-accent-ring',
        size === 'small' ? 'h-[30px]' : size === 'row' ? 'h-[34px] px-[11px]'
          : size === 'phone' ? 'h-[46px] px-[11px]' : 'h-9 px-[11px]',
        readOnly ? 'bg-surface-alt' : 'bg-surface',
        !width && 'w-full')}
    >
      {prefix && <span className="shrink-0 text-[13.5px] text-text-muted">{prefix}</span>}
      <input
        aria-label={label}
        inputMode="decimal"
        value={value}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(event) => onChange?.(event.target.value)}
        className={cn('tnum min-w-0 flex-1 border-none bg-transparent p-0 focus:outline-none',
          'focus-visible:shadow-none placeholder:font-normal placeholder:text-text-faint',
          size === 'field' ? 'text-[14px] font-bold' : 'text-[13.5px] font-semibold',
          align === 'right' && 'text-right',
          dim ? 'text-text-faint' : 'text-text')}
      />
      {unit && (
        <span className={cn('shrink-0 whitespace-nowrap text-text-faint',
          size === 'small' ? 'text-[11.5px] font-medium' : size === 'row' ? 'text-[11.5px]'
            : size === 'phone' ? 'text-[12.5px]' : 'text-[12px]')}>
          {unit}
        </span>
      )}
    </label>
  )
}
